import { BaseModel, CreateBaseModel } from './base.model';
import { JsonObject } from '../helpers';
import { RootRole } from '../services/auth.service';

export const RootRoleLabels: Record<RootRole, string> = {
  'root:owner': 'Owner',
  'root:admin': 'Admin',
  'root:auditor': 'Auditor',
};

export class RootUserModel extends BaseModel {
  partnerId: string;
  name: string;
  email: string;
  role: RootRole;
  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof RootUserModel, string>;

    this.partnerId = data.partnerId || '';
    this.name = data.name || '';
    this.email = data.email || '';
    this.role = data.role ? (data.role as RootRole) : 'root:auditor';
  }
}

export class CreateRootUserModel extends CreateBaseModel {
  partnerId: string;
  name: string;
  email: string;
  role: RootRole;
  constructor(rootUser: RootUserModel) {
    super();

    this.partnerId = rootUser.partnerId;
    this.name = rootUser.name;
    this.email = String(rootUser.email).trim().toLowerCase();
    this.role = rootUser.role;
  }
}
